import "./index.css";

import App from "App";
import ReactDOM from "react-dom/client";

import { disableReactDevTools } from "@fvilers/disable-react-devtools";
import { StoreProvider } from "Store";
import { StrictMode } from "react";

if (import.meta.env.PROD) {
	disableReactDevTools();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<StrictMode>
		<StoreProvider>
			<App />
		</StoreProvider>
	</StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register();
